import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { StickyCallBar } from './components/StickyCallBar';
import { Home } from './pages/Home';
import { Chauffage } from './pages/Chauffage';
import { Ramonage } from './pages/Ramonage';
import { Plomberie } from './pages/Plomberie';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wk06ksad07ra">
      <ScrollToTop data-id="element-1" data-mp="2wjqi594yq8np" />
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-2" data-mp="2wj8dpp85co4p">
        <a href="#contenu" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-navy-800 focus:px-4 focus:py-2 focus:font-display focus:font-bold focus:text-white" data-id="element-3" data-mp="28tw62tsgwo4i">
          Aller au contenu
        </a>
        <Header data-id="element-4" data-mp="3mlax56bfqdtg" />
        <main id="contenu" className="flex-1" data-id="element-5" data-mp="3mkrc3gqhn9b7">
          <Routes data-id="element-6" data-mp="3mjg8bgx1m1k3">
            <Route path="/" element={<Home data-id="element-8" data-mp="3rbzn2h7gv2qh" />} data-id="element-7" data-mp="3rc9dg5wfbbwp" />
            <Route path="/chauffage" element={<Chauffage data-id="element-10" data-mp="3recc1ebn6dd1" />} data-id="element-9" data-mp="3rdkg22e4udm8" />
            <Route path="/ramonage-debistrage" element={<Ramonage data-id="element-12" data-mp="5gfdawxfswe" />} data-id="element-11" data-mp="5opww5kum4f" />
            <Route path="/plomberie-sanitaires" element={<Plomberie data-id="element-14" data-mp="2zlv8iz6e19x6" />} data-id="element-13" data-mp="7suzhf7pr6a" />
            <Route path="/contact" element={<Contact data-id="element-16" data-mp="2znfy0adui2o6" />} data-id="element-15" data-mp="2zmo5x9jgin2n" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-18" data-mp="33ngdzzglelxc" />} data-id="element-17" data-mp="33m5bs42spm8c" />
          </Routes>
        </main>
        <Footer data-id="element-19" data-mp="38l8eviz7tido" />
        <StickyCallBar data-id="element-20" data-mp="38kqau06b9zv7" />
      </div>
    </BrowserRouter>;
}